import { useState } from 'react'
import { css, Theme } from '@emotion/react'
import { Box, Typography, Collapse } from '@mui/material'

import { returnFeed } from '~/utils/returnFeed'

const createData = (
  state: boolean,
  setter,
  question: string,
  answer: string
) => {
  return { state, setter, question, answer }
}

const FAQListWebAd = () => {
  const [openOne, setOpenOne] = useState(false)
  const [openTwo, setOpenTwo] = useState(false)
  const [openThree, setOpenThree] = useState(false)
  const [openFour, setOpenFour] = useState(false)

  const rows = [
    createData(
      openOne,
      setOpenOne,
      'リスティング広告とはどういうものですか？',
      `検索エンジン上でユーザーが検索したキーワードを元に表示される広告のことです。
      リスティング広告は年々需要が伸びており、ディスプレイ広告と合わせて国内のインターネット広告全体のシェアの7割を占めています！`
    ),
    createData(
      openTwo,
      setOpenTwo,
      'リスティング広告ではどういったメリットがありますか？',
      `数万円から運用をスタートでき、時期に合わせて予算を調整できるのがメリットの一つです。
      適切な運用をすれば1か月などの短期間で結果が出ます！即効性を求める方にピッタリです！`
    ),
    createData(
      openThree,
      setOpenThree,
      'リスティング広告のデメリットはありますか？',
      `掲載後もPDCAを回して成果を出していくことが、リスティング広告の最重要ポイントです。
      運用の柔軟性が高い反面、実績やノウハウがないと際限なく工数が重なってしまう事例が数多くあります。`
    ),
    createData(
      openFour,
      setOpenFour,
      '自社で広告運用をするのと、プロに運用してもらうのは何が違うんですか？',
      `前述の通り、最短最速で成果を出すためのノウハウを持っていることです。
      eduadでは、最短で成果を出し最終的に自社運営ができるようにサポートしていきます。`
    ),
  ]

  return (
    <>
      <Box css={styles.faq_container}>
        <Box css={styles.title_container}>
          <Typography color='primary' variant='h2' css={styles.section_title}>
            ウェブ広告・オンライン集客・マーケティング支援について
          </Typography>
        </Box>
        <ul css={styles.list}>
          {rows.map(row => (
            <li
              key={row.question}
              css={styles.item}
              className={row.state ? 'isActive' : null}>
              <div
                css={styles.accordion_head}
                onClick={() => row.setter(!row.state)}>
                {row.question}
              </div>
              <div>
                <Collapse
                  in={row.state}
                  timeout={{
                    enter: 300,
                    exit: 500,
                  }}
                  unmountOnExit>
                  <div css={styles.accordion_body}>
                    <p>{returnFeed(row.answer)}</p>
                  </div>
                </Collapse>
              </div>
            </li>
          ))}
        </ul>
      </Box>
    </>
  )
}

const styles = {
  faq_container: css`
    margin-left: 0;
    padding: 20px;
  `,
  title_container: css`
    width: 100%;
    padding: 20px 0%;
    border-bottom: 1px solid #dfdddd;
    @media (min-width: 960px) {
      padding: 50px 0;
    }
  `,
  section_title: css`
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    text-align: right;
    &:before {
      content: '-';
      margin-right: 1rem;
    }
  `,
  list: css`
    list-style: none;
    padding-inline-start: 0;
    @media (min-width: 960px) {
      margin-left: 50px;
    }
  `,
  item: css`
    cursor: pointer;
    padding-left: 10px;
    border-bottom: 0.2px solid #dfdddd;
  `,
  accordion_head: (theme: Theme) => css`
    position: relative;
    font-family: 'Noto sans JP', sans-serif;
    font-weight: 500;
    font-size: 0.9rem;
    padding: 30px 40px 30px 0;
    color: ${theme.palette.primary.main};
    &:after {
      content: '\\f078';
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      position: absolute;
      right: 10px;
      transition: all 0.3s ease-in-out;
    }
    .isActive &:after {
      transform: rotate(180deg);
    }
    @media (min-width: 960px) {
      font-size: 1.2rem;
    }
  `,
  accordion_body: (theme: Theme) => css`
    padding: 20px;
    color: ${theme.palette.primary.main};
  `,
}

export default FAQListWebAd
